// IMPORTANT: host-redirect MUST be the first import. It rewrites the URL
// off any *.run.app host onto explorer.samsurveyor.com before anything
// touches Hanko. See src/host-redirect.js.
import './host-redirect';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { DndProvider } from 'react-dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import './styles/design-tokens.css';
import '@cloudsam/ui/dist/styles.css'; // shared shell + components; must follow the tokens
import './styles/app-base.css';
import './hanko-init'; // must be imported before any auth-aware component
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import IdleSessionGate from './components/IdleSessionGate';

// Surface identity (surface-identity-and-shell.md §1): the tint is declared once
// on the app root and inherited by every panel via --color-surface-*. Set on the
// #root element rather than a JSX wrapper so portalled overlays that mount inside
// #root inherit it too.
const rootEl = document.getElementById('root');
rootEl.classList.add('app--explorer');

const root = ReactDOM.createRoot(rootEl);
root.render(
    <React.StrictMode>
        <AuthProvider>
            <ProtectedRoute>
                {/* Inside ProtectedRoute, so the idle clock only runs for
                    somebody who is actually signed in. */}
                <IdleSessionGate>
                    <DndProvider options={HTML5toTouch}>
                        <App />
                    </DndProvider>
                </IdleSessionGate>
            </ProtectedRoute>
        </AuthProvider>
    </React.StrictMode>
);
